import React, { useState, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { stateFromHTML } from "draft-js-import-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function TextEditor(props) {
  const [editorState, setEditorState] = useState(() => {
    // Initialize editor state
    if (props.Value) {
      const contentState = stateFromHTML(props.Value);
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  });

  useEffect(() => {
    // Update editor state when props.Value changes
    if (props.Value) {
      const contentState = stateFromHTML(props.Value);
      const newEditorState = EditorState.push(
        editorState,
        contentState,
        "insert-characters"
      );
      setEditorState(newEditorState);
    }
  }, []);

  const handleEditorChange = (newEditorState) => {
    setEditorState(newEditorState);
    const contentState = newEditorState.getCurrentContent();
    const html = draftToHtml(convertToRaw(contentState));
    props.SaveTextEditorValue(html);
  };

  return (
    <Editor
      editorKey="text-editor" // Ensure a unique key is set
      editorState={editorState}
      onEditorStateChange={handleEditorChange}
    />
  );
}
